export default __webpack_public_path__ + "static/media/l3.12c1461d.png";